var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Functional-/-Minus-/-Special",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("g", {
    id: "minus",
    transform: "translate(5.000000, 13.000000)",
    fill: "#00A3E0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.29675,0.44175 L0.99025,0.44175 C0.668775,0.44175 0.40785,0.7025 0.40785,1.024675 C0.40785,1.3465 0.668775,1.6055 0.99025,1.6055 L17.29675,1.6055 C17.61875,1.6055 17.8795,1.3465 17.8795,1.024675 C17.8795,0.7025 17.61875,0.44175 17.29675,0.44175 Z",
    id: "minus1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusZoom);
export default __webpack_public_path__ + "static/media/minus-zoom.ce902f9e9ba9ff3b880df5f8341c298e.svg";
export { ForwardRef as ReactComponent };